//@flow
import { connect } from 'react-redux';
import PendingOrderStatus from './PendingOrderStatus';
import { shouldShowPendingOrderPanelSelector } from '../../../../modules/Subscriptions';
import type { StateProps } from './PendingOrderStatus';
import type { StateType } from '../../../../modules/reducers';

const mapStateToProps = (state: StateType): StateProps => ({
  hasPendingOrders: shouldShowPendingOrderPanelSelector(state),
});

export default connect(mapStateToProps)(PendingOrderStatus);
